<template>
  <a-modal
    :title="$t('title.countingAdd')"
    :visible="visible"
    width="60%"
    :destroyOnClose="true"
    :centered="true"
    :confirmLoading="loading"
    @ok="save"
    @cancel="cancel">
    <a-spin :spinning="loading">
      <a-form-model ref="form" :model="detail" :rules="rules">
        <a-row>
          <a-col :md="8" :sm="10">
            <a-form-model-item :label="$t('business.label.storer')" :label-col="labelCol" :wrapper-col="wrapperCol" prop="sku.storer.id">
              <a-select v-model="detail.sku.storer.id" @change="changeStorer" allowClear>
                <a-select-option v-for="d in storerData" :key="d.id">{{ d.name }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :md="8" :sm="10">
            <a-form-model-item :label="$t('business.label.itemNo')" :label-col="labelCol" :wrapper-col="wrapperCol" prop="sku.item.no">
              <a-input-search readOnly
                              :value="detail.sku?.item?.no"
                              @dblclick="()=>{if(storerVerify()){$refs.skuModal.open({ 'storer.ids': [compareStorerId] })}}"
                              @pressEnter="()=>{if(storerVerify()){$refs.skuModal.open({ 'storer.ids': [compareStorerId] })}}"
                              @search="()=>{if(storerVerify()){$refs.skuModal.open({ 'storer.ids': [compareStorerId] })}}"/>
              <sku-modal ref="skuModal" @change="onSkuSelected"></sku-modal>
            </a-form-model-item>
          </a-col>
          <a-col :md="8" :sm="10">
            <a-form-model-item :label="$t('business.label.itemName')" :label-col="labelCol" :wrapper-col="wrapperCol" prop="sku.item.name">
              <a-input :value="detail.sku?.item?.name" disabled/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :md="8" :sm="10">
            <a-form-model-item :label="$t('business.label.specification')" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input :value="detail.sku?.pack?.specification" disabled/>
            </a-form-model-item>
          </a-col>
          <a-col :md="8" :sm="10">
            <a-form-model-item :label="$t('business.label.factor')" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input :value="detail.sku?.pack?.factor" disabled/>
            </a-form-model-item>
          </a-col>
          <a-col :md="8" :sm="10">
            <a-form-model-item :label="$t('business.label.uom')" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input :value="detail.sku?.pack?.uom" disabled/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :md="8" :sm="12">
            <a-form-model-item :label="$t('business.label.lotNo')" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input :value="detail.sku?.lot?.no" disabled/>
            </a-form-model-item>
          </a-col>
          <a-col :md="8" :sm="12">
            <a-form-model-item :label="$t('business.label.productionDate')" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input :value="detail.sku?.lot?.productionDate" disabled/>
            </a-form-model-item>
          </a-col>
          <a-col :md="8" :sm="12">
            <a-form-model-item :label="$t('business.label.validUntil')" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input :value="detail.sku?.lot?.validUntil" disabled/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :md="8" :sm="10">
            <a-form-model-item :label="$t('business.label.locationNo')" :label-col="labelCol" :wrapper-col="wrapperCol" prop="location.no">
              <a-input-search readOnly
                              :value="detail.location?.no"
                              @dblclick="()=>$refs.locationModal.open({locationType: 5})"
                              @pressEnter="()=>$refs.locationModal.open({locationType: 5})"
                              @search="()=>$refs.locationModal.open({locationType: 5})"/>
              <location-modal ref="locationModal"
                              @change="(loc)=>{
                                if(loc.length>0){
                                  detail.location=loc[0]
                                }else{
                                  detail.location=new Location()
                                }
                              }"/>
            </a-form-model-item>
          </a-col>
          <a-col :md="8" :sm="10">
            <a-form-model-item :label="$t('business.label.containerNo')" :label-col="labelCol" :wrapper-col="wrapperCol" prop="container.no">
              <a-input-search readOnly
                              :value="detail.container?.no"
                              @dblclick="()=>$refs.containerModal.open()"
                              @pressEnter="()=>$refs.containerModal.open()"
                              @search="()=>$refs.containerModal.open()"/>
              <container-modal ref="containerModal"
                               @change="(ctn)=>{
                                if(ctn.length>0){
                                  detail.container=Object.assign(new Container(), ctn[0])
                                }else{
                                  detail.container=new Container()
                                }
                              }"/>
            </a-form-model-item>
          </a-col>
          <a-col :md="8" :sm="10">
            <a-form-model-item :label="$t('business.label.actualCountQuantity')" :label-col="labelCol" :wrapper-col="wrapperCol" prop="quantity">
              <a-input-number v-model="detail.quantity" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-form-model-item :label="$t('business.label.inventoryReason')" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }" prop="reasons">
            <a-textarea v-model="detail.reasons" :rows="5"/>
          </a-form-model-item>
        </a-row>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import {CountingDetail, CountingOrder} from '@/api/dto/order/CountingOrder'
  import {findAll, post} from '@/api/Api'
  import api from '@/api'
  import SkuModal from '@/views/modal/SkuModal.vue'
  import LocationModal from '@/views/modal/LocationModel.vue'
  import ContainerModal from '@/views/modal/ContainerModal.vue'
  import Vue from 'vue'
  import {OPERATOR, WAREHOUSE} from '@/store/mutation-types'
  import {Sku} from '@/api/dto/common/Sku'
  import {Container} from '@/api/dto/common/Container'
  import {Location} from '@/api/dto/common/Location'
  import {BaseObject} from '@/api/dto/BaseObject'

  export default {
    name: 'TemporaryCountingAdd',
    computed: {
      Container() {
        return Container
      },
      Location() {
        return Location
      }
    },
    components: {ContainerModal, LocationModal, SkuModal},
    data() {
      return {
        visible: false,
        loading: false,
        order: new CountingOrder(),
        detail: new CountingDetail(),
        warehouse: Vue.ls.get(WAREHOUSE),
        operator: Vue.ls.get(OPERATOR),
        compareStorerId: undefined,
        storerData: [],
        labelCol: {span: 8},
        wrapperCol: {span: 16},
        rules: {
          'sku.storer.id': [
            {required: true, message: '请选择货主'}
          ],
          'sku.item.no': [
            {required: true, message: '请选择SKU'}
          ],
          'location.no': [
            {required: true, message: '请选择货位'}
          ],
          quantity: [
            {required: true, message: '请输入盘点数量'}
          ],
          reasons: [
            {required: true, message: '请输入盘点原因'}
          ]
        }
      }
    },
    props: {
      orderType: {
        type: Object,
        default: null
      }
    },
    mounted() {
      findAll('storerFactory', {available: true}).then(res => {
        if (res.success) {
          this.storerData = res.result
        }
      })
    },
    methods: {
      changeStorer() {
        if (this.compareStorerId !== undefined && this.detail.sku.storer.id !== undefined && this.detail.sku.storer.id !== this.compareStorerId) {
          let that = this
          that.$confirm({
            title: '更改货主将清空已选择的SKU信息',
            content: '是否确定',
            onOk() {
              that.detail.sku = new Sku()
            },
            onCancel() {
            },
            centered: true
          })
        }
        this.compareStorerId = this.detail.sku.storer.id
      },
      onSkuSelected(data) {
        this.detail.sku = new Sku(BaseObject.merge(data[0], 'sku'))
      },
      open() {
        this.order.warehouse = this.warehouse
        this.order.orderType = this.orderType //临时盘点
        this.order.dataSource = 4
        this.visible = true
      },
      save() {
        this.$refs.form.validate((success) => {
          // 验证表单没错误
          if (success) {
            this.loading = true
            let order = JSON.parse(JSON.stringify(this.order))
            let detail = JSON.parse(JSON.stringify(this.detail))
            order.storer = detail.sku.storer
            detail.serialNumber = this.detail.serialNumber.skipNulls()
            detail.container = this.detail.container.skipNulls()
            order.details.push(detail)
            post(api.countingSave, {type: 'inventoryCounter'}, order).then(res => {
              if (res.success) {
                this.$message.success('新增成功')
                this.cancel()
              }
            }).finally(() => {
              this.loading = false
            })
          }
        })
      },
      clear() {
        this.order = new CountingOrder()
        this.detail = new CountingDetail()
        this.compareStorerId = undefined
      },
      cancel() {
        this.clear()
        this.visible = false
      },
      storerVerify() {
        if (this.compareStorerId === undefined) {
          this.$message.warning('请先选择货主')
          return false
        }
        return true
      }
    }
  }
</script>

<style scoped>

</style>